<template>
<div >
    <basic-container v-loading="loading">
        <el-row>
            <el-col span="2" style="line-height:40px;min-weight:80px;flex-grow: 0;">项目名称 : </el-col>
            <el-col span="6">
                <el-select v-model="projectName" @change="changeProject"  placeholder="请选择项目">
                    <el-option
                        v-for="item in projectNameList"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                    </el-option>
                </el-select>
            </el-col>
        </el-row>

         <el-divider></el-divider>
        <el-tabs v-model="activeName" type="card"   @tab-click="e=>handleClick()">
            <el-tab-pane label="项目配置" :name='1'></el-tab-pane>
            <el-tab-pane label="区域配置" :name='2'></el-tab-pane>
            <el-tab-pane label="合同配置" :name='3'></el-tab-pane>
            <el-tab-pane label="设备配置" :name='4'></el-tab-pane>
            <el-tab-pane label="工单配置" :name='5'></el-tab-pane>
            <el-tab-pane label="考核监督" :name='6'></el-tab-pane>
            <el-tab-pane label="工程管理" :name='7'></el-tab-pane>
            <el-tab-pane label="综合巡查" :name='8'></el-tab-pane>
            <el-tab-pane label="其他配置" :name='99'></el-tab-pane>

            <dictionary-form
                :tabledata='data'
                :projectId='projectId'
                :activeName="activeName"
                :paramData="paramData"
                @handleClick="handleClick"
                @getProjectParamList="getProjectParamList"

            ></dictionary-form>
            <div style="padding:100px" v-if="!data.length && !paramData.length">
                <avue-empty desc="暂无内容" :size="200"></avue-empty>
            </div>
        </el-tabs>
    </basic-container>
</div>
</template>
<script>
import dictionaryForm from './dictionary-form';
import {
    getMap,
    getProjects,
    getProjectParamList
} from "@/api/crmedical/project-dictionary/project-dictionary"
export default {
    components:{dictionaryForm},
    data(){
        return{
            loading:true,
            data:[],
            projectName:'',
            projectId:1,
            projectNameList:[],
            activeName:1,
            paramData:[],
        }
    },
    created(){
        // 获取项目下拉列表数据
        getProjects().then(res=>{
            this.projectNameList = res.data;
            this.projectId = this.projectNameList[0].id;
            this.projectName = this.projectNameList[0].name;
            this.handleClick();
        }).catch(err=>{
            this.loading = false;
        })
    },
    methods:{
        // 改变项目的时候
        changeProject(e){
            this.projectId = e;
            this.handleClick();


        },
        //获取页面内容
        handleClick(data){

            this.loading = true
            if(data){

                this.data = data;
                this.getMap();
                return;
            }

            switch(this.activeName){
                case 1:this.setLabel(1);break;
                case 2:this.setLabel(2);break;
                case 3:this.setLabel(3);break;
                case 4:this.setLabel(4);break;
                case 5:this.setLabel(5);break;
                case 6:this.setLabel(6);break;
                case 7:this.setLabel(7);break;
                case 8:this.setLabel(8);break; 
                case 99:this.setLabel(99);break;
           }

        },
        setLabel(type){
            if(type == 1){
                this.data=[
                  {
                      label:'供应商类型',
                      code:'project_partner_type',
                      dictionaryId:'project_partner_type',
                      showButtonAdd:false,
                      value:[],
                  },
                  {
                    label:'供应商等级',
                    dictionaryId:'project_partner_level',
                    showButtonAdd:false,
                    value:[],
                  },

                ];
                this.paramData = [
                  {
                    paramValue: '',
                    paramKey: 'project.social_circle_publisher_name',
                    paramName: '项目社交圈发布人名称',
                    remark: '',
                    maxlength: 30,
                    showWordLimit: true,
                    rules: [
                      { required: true, message: '请输入社交圈发布人名称', trigger: 'blur' },
                    ],
                  },
                  {
                    paramValue: '',
                    paramKey: 'project.social_circle_publisher_avatar',
                    paramName: '项目社交圈发布人头像url',
                    remark: '',
                    maxlength: 200,
                    showWordLimit: true,
                    rules: [
                      { required: true, message: '请输入社交圈发布人头像url', trigger: 'blur' },
                    ],
                  },
                  {
                    paramValue: '',
                    paramKey: 'shop.sync_service_url',
                    paramName: '商城同步服务地址',
                    remark: '',
                    maxlength: 200,
                    showWordLimit: true,
                    rules: [
                      { required: true, message: '请输入商城同步服务地址', trigger: 'blur' },
                    ],
                  },
                ];

            }else if(type==2){
                this.data=[
                    {
                        label:'区域类型',
                        dictionaryId:'project_area_data_type',
                        showButtonAdd:false,
                        value:[],
                    },
                    {
                        label:'用途类型',
                        dictionaryId:'project_area_use_type',
                        showButtonAdd:false,
                        value:[],
                    },
                ];
                this.paramData = [
                    {
                        paramValue:'',
                        paramKey:'mark.area.code_pic_type',
                        paramName:'区域标识类型',
                        remark:'',
                        type:'select',
                        dictData:[
                            {label:'二维码',value:1},
                            {label:'条形码',value:2},
                        ],
                        rules:[
                            { required: true, message: '请选择设备标识类型', trigger: 'blur' },

                        ],
                    },
                    {
                        paramValue:'',
                        paramKey:'mark.area.code_pic_width',
                        paramName:'区域标识宽度',
                        remark:'',
                        maxlength:3,
                        showWordLimit:true,
                        rules:[
                            { required: true, message: '请输入区域标识宽度', trigger: 'blur' },
                            {
                                validator: (rule, value, callback) => {
                                if (/^[1-9]+[0-9]{0,3}$/.test(value) == false) {
                                    callback(new Error("请输入开头不为0,最大值为999的自然数"));
                                } else {
                                    callback();
                                }
                                }, trigger: 'change'
                            },

                        ]
                    },
                     {
                        paramValue:'',
                        paramKey:'mark.area.code_pic_height',
                        paramName:'区域标识高度',
                        remark:'',
                        maxlength:3,
                        showWordLimit:true,
                        rules:[
                            { required: true, message: '请输入区域标识高度', trigger: 'blur' },
                            {
                                validator: (rule, value, callback) => {
                                if (/^[1-9]+[0-9]{0,3}$/.test(value) == false) {
                                    callback(new Error("请输入开头不为0,最大值为999的自然数"));
                                } else {
                                    callback();
                                }
                                }, trigger: 'change'
                            },
                        ]
                    },
                ]




            }else if(type==3){
                this.data=[
                    {
                        label:'合同类型',
                        dictionaryId:'project_contract_type',
                        showButtonAdd:false,
                        value:[],
                    },
                  {
                    label:'合同发票税率',
                    dictionaryId:'project_contract_invoice_tax_rate',
                    showButtonAdd:false,
                    value:[],
                  },
                ];
                this.paramData=[];
            }else if(type==4){
                this.data=[
                  {
                    label:'计量单位',
                    dictionaryId:'project_consumable_measuring_unit',
                    showButtonAdd:false,
                    value:[],
                  },
                  {
                    label:'可选操作',
                    dictionaryId:'project_device_inspect_operation',
                    showButtonAdd:false,
                    value:[],
                  },
                ];
                this.paramData = [
                    {
                        paramValue:'',
                        paramKey:'mark.device.code_pic_type',
                        paramName:'设备标识类型',
                        remark:'',
                        type:'select',
                        dictData:[
                            {label:'二维码',value:1},
                            {label:'条形码',value:2},
                        ],
                        rules:[
                            { required: true, message: '请选择设备标识类型', trigger: 'blur' },

                        ],
                    },
                    {
                        paramValue:'',
                        paramKey:'mark.device.code_pic_width',
                        paramName:'设备标识宽度',
                        remark:'',
                        maxlength:3,
                        showWordLimit:true,

                        rules:[
                            { required: true, message: '请输入设备标识宽度', trigger: 'blur' },
                            {
                                validator: (rule, value, callback) => {
                                if (/^[1-9]+[0-9]{0,3}$/.test(value) == false) {
                                    callback(new Error("请输入开头不为0,最大值为999的自然数"));
                                } else {
                                    callback();
                                }
                                }, trigger: 'change'
                            },
                        ]
                    },
                     {
                        paramValue:'',
                        paramKey:'mark.device.code_pic_height',
                        paramName:'设备标识高度',
                        remark:'',
                        maxlength:3,
                        showWordLimit:true,
                        rules:[
                            { required: true, message: '请输入设备标识高度', trigger: 'blur' },
                            {
                                validator: (rule, value, callback) => {
                                if (/^[1-9]+[0-9]{0,3}$/.test(value) == false) {
                                    callback(new Error("请输入开头不为0,最大值为999的自然数"));
                                } else {
                                    callback();
                                }
                                }, trigger: 'change'
                            },
                        ]
                    },
                ]

            }else if(type==5){
                this.data=[
                  {
                    label:'评价对象',
                    dictionaryId:'project_order_evaluate_target',
                    showButtonAdd:false,
                    maxlength:4,
                    value:[],
                  },
                  {
                    label:'服务标签',
                    dictionaryId:'project_order_service_target',
                    showButtonAdd:false,
                    value:[],
                  },
                ];
                this.paramData=[
                  {
                    paramValue:'',
                    paramKey:'order.grab_single_max_num',
                    paramName:'工单抢单允许上限数',
                    remark:'',
                    maxlength:10,
                    showWordLimit:true,
                    rules:[
                      { required: true, message: '请输入工单抢单允许上限数', trigger: 'blur' },
                      {
                        validator: (rule, value, callback) => {
                          if (/^[0-9]+[0-9]{0,3}$/.test(value) == false) {
                            callback(new Error("请输入最大值为999的自然数"));
                          } else {
                            callback();
                          }
                        }, trigger: 'change'
                      },
                    ]
                  },
                ];

            }else if(type==6){
              this.data=[
                {
                  label:'考核对象',
                  dictionaryId:'project_examine_service_type',
                  showButtonAdd:false,
                  value:[],
                },
              ];
              this.paramData=[];
            }else if(type==7){
              this.data=[
                {
                  label:'项目节点',
                  dictionaryId:'engineering_progress_stage',
                  showButtonAdd:false,
                  value:[],
                },
                {
                  label:'立项方式',
                  dictionaryId:'engineering_startup_way',
                  showButtonAdd:false,
                  value:[],
                },
              ];
              this.paramData=[];
            }else if(type==8){
              this.data=[
                {
                  label:'巡查标准',
                  dictionaryId:'project_general_inspect_type',
                  showButtonAdd:false,
                  value:[],
                },
                {
                  label:'可选操作',
                  dictionaryId:'project_general_inspect_operation',
                  showButtonAdd:false,
                  value:[],
                },
              ];
              this.paramData=[];
            }else if(type==99){
                this.data=[];
                this.paramData = [
                    // {
                    //     paramValue:'',
                    //     paramKey:'mark.server_url',
                    //     paramName:'标识服务地址',
                    //     remark:'',
                    //     type:'text',
                    //     rules:[
                    //         { required: true, message: '请输入标识服务地址', trigger: 'blur' },
                    //
                    //         {
                    //             validator: (rule, value, callback) => {
                    //             if (/^(http|ftp|https):\/\/[\w\-_]+(\.[\w\-_]+)+([\w\-\.,@?^=%&:/~\+#]*[\w\-\@?^=%&/~\+#])?$/.test(value) == false) {
                    //                 callback(new Error("请按照 http://[ip]:[port]/ v4ward 格式输入"));
                    //             } else {
                    //                 callback();
                    //             }
                    //             }, trigger: 'change'
                    //         }
                    //     ],
                    //
                    // },
                ]

            }

            this.getMap();
        },
        // 获取数据
        getMap(){
            getMap({
                projectId:this.projectId,
                tabId:this.activeName
            }).then(res=>{
                for(let key in res.data){
                    this.data.forEach((item)=>{
                        if(item.dictionaryId==key){
                            item.value = res.data[key]
                            item.value.forEach(item=>{
                                item.show = false;
                            })
                        }
                    })
                }
                this.getProjectParamList()
                this.loading = false
            }).catch(err=>{
                this.loading = false;
            })
            setTimeout(()=>{
                this.loading = false;
            },5000)
        },
        getProjectParamList(){
            this.loading = true;
            getProjectParamList({
                projectId:this.projectId,
                tabId:this.activeName
            }).then(({data})=>{
                console.log(data)

                data.forEach(ele=>{
                    this.paramData.forEach(item=>{
                        if(item.paramKey == ele.paramKey){

                            item.paramName = ele.paramName;
                            item.paramValue = ele.paramValue;
                            item.remark = ele.remark;
                        }
                    })
                })
                this.loading = false;
            })
        }
    }
}
</script>
